<template>
    <div class="flex-fill">
        <div>
            <img class="pr-2" src="@/assets/svg/menu-dddddd.svg">
            <img
                id="go-back"
                class="pr-2"
                src="@/assets/svg/corner-up-left-dddddd.svg"
                @click="goBack()"
            >
            <img src="@/assets/svg/chervron-right-dddddd.svg">
        </div>
        <div class="services-menu mt-3 pb-3 pr-1 sidemenu">
          <ul
            class="list-group text-uppercase main slide"
            :class="[mainClass, currentLevel > 0 ? 'no-shadow' : '']"
            v-if="navItems.length"
          >
            <li
              class="list-group-item"
              v-for="(navItem, index) in navItems"
              :key="index + 0"
              @click.stop="navigate(navItem, index)"
            >
              {{ $t(navItem.name) }}
              <img src="@/assets/svg/plus-ffffff.svg" v-if="navItem.addLink" @click.stop="add(navItem.addLink)">
              <ul
                class="sub list-group slide move-in"
                :class="[mainClass, currentLevel > 1 ? 'no-shadow' : '']"
                :style="[currentLevel >= 1 && position[0] === index ? {'visibility': 'visible', 'opacity': 1} : {'visibility': 'hidden', 'max-height':'100%', 'overflow':'hidden'}]"
              >
                <li
                  class="list-group-item"
                  v-for="(subNavLvl1, index1) in navItem.children"
                  :key="index1 + 0"
                  @click.stop="navigate(subNavLvl1, index1)"
                  v-if="isGroupAccount || subNavLvl1.name != 'nav.settings.nav.general.nav.persons-import'"
                >
                  {{ $t(subNavLvl1.name) }}
                  <img src="@/assets/svg/plus-ffffff.svg" v-if="subNavLvl1.addLink" @click.stop="add(subNavLvl1.addLink)">
                  <ul
                    class="sub list-group slide move-in"
                    :class="[mainClass, currentLevel > 2 ? 'no-shadow' : '']"
                    :style="[currentLevel >= 2 && position[1] === index1 ? {'visibility': 'visible', 'opacity': 1} : {'visibility': 'hidden', 'max-height':'100%'}]"
                  >
                    <li
                      class="list-group-item"
                      v-for="(navItem2, index2) in subNavLvl1.children"
                      :key="index2 + 0"
                      @click.stop="navigate(navItem2, index2)"
                      v-if="isGroupAccount || navItem2.name != 'nav.settings.nav.general.nav.persons-import'"
                    >
                      {{ $t(navItem2.name) }}
                      <img src="@/assets/svg/plus-ffffff.svg" v-if="navItem2.addLink" @click.stop="add(navItem2.addLink)">
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      parentClass: 'current',
      position: [],
      navigating: false
    }
  },
  props: {
    navItems: {
      type: Array,
      required: true
    }
  },
  computed: {
    isGroupAccount () {
      return this.$store.getters.account.name.includes('Groepsreizen')
    },
    mainClass () {
      return this.position.length ? 'move' + this.position.length : this.parentClass
    },
    currentLevel () {
      return this.position.length
    }
  },
  methods: {
    goBack: function () {
      if (this.position.length) {
        this.position.pop()
      }
    },
    goTo: function (path) {
      this.$router.push({path: path})
    },
    navigate: function (navItem, index) {
      if (this.navigating) {
        return
      }
      this.navigating = true
      // If we are navigating to already opened section, than just manually push position index
      if (this.$route.path === navItem.path && navItem.children.length) {
        this.position.push(index)
      } else {
        // FixMe: we want to be able to show child items of non valid route paths, but since we have no non-valid routes (thanks to catch all * redirect to home rule)
        // we are comparing resolved route with intended route of item and if it matches, it means no redirection happened and item exists
        // else, we just check if items has children and move menu manually one level deeper
        let resolvedRoute = this.$router.resolve({path: navItem.path})
        if (resolvedRoute.route.path !== navItem.path) {
          if (navItem.children.length) {
            this.position.push(index)
          }
        } else {
          this.$router.push({path: navItem.path})
        }
      }
      // Delay to prevent double clicks
      // p.s. duration is equal to animation time of menu
      this.$_.delay(() => { this.navigating = false }, 500)
    },
    add: function (addLink) {
      this.$router.push({path: addLink})
    },
    findPosition (to) {
      let trace = {
        position: []
      }
      this.recursiveFind(this.navItems, to.path.split('/'), trace)
      this.position = trace.position
    },
    recursiveFind (items, path, trace = {}, level = 1) {
      items.forEach((item, index) => {
        let itemPath = item.path.split('/')[level]
        let selectedPath = path[level]
        // Only if we have a matching path and that item has children, we set position
        // because we don't want to go into depth if there is nothing to display
        if (itemPath && selectedPath && itemPath === selectedPath && item.children.length) {
          trace.position.push(index)
          this.recursiveFind(item.children, path, trace, ++level)
        }
      })
    }
  },
  created () {
    this.findPosition(this.$router.currentRoute)
  },
  mounted () {
    this.findPosition(this.$router.currentRoute)
  },
  watch: {
    '$route' (to) {
      this.findPosition(to)
    }
  }
}
</script>

<style scoped>
   .list-group.no-shadow  {
        box-shadow: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/navigation/Dynamic.vue